import { useCallback, useState } from "react";
import { Info } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";

// Onay GEREKTİREN yasal metin (ör. KVKK, Açık Rıza): kutuya basınca metin açılır,
// sonuna kadar okununca onaylanabilir. `checked`/`onChange` üst bileşenden gelir.
export function ApprovalConsent({ title, linkLabel, suffix = "okudum ve onaylıyorum.", acceptLabel = "Okudum, onaylıyorum", text, checked, onChange, hint, testid }) {
  const [open, setOpen] = useState(false);
  const [read, setRead] = useState(false);
  const onScroll = (e) => {
    const el = e.currentTarget;
    if (el.scrollHeight - el.scrollTop - el.clientHeight < 8) setRead(true);
  };
  const measure = useCallback((node) => {
    if (node && node.scrollHeight <= node.clientHeight + 8) setRead(true);
  }, []);
  return (
    <div>
      <div className="flex items-start gap-3">
        <Checkbox
          checked={checked}
          onCheckedChange={() => {
            if (checked) { onChange(false); return; }
            if (read) onChange(true);
            else setOpen(true);
          }}
          data-testid={testid}
          className="mt-0.5"
        />
        <span className="text-sm text-slate-700">
          <button type="button" onClick={() => setOpen(true)} className="text-[#10B981] font-semibold hover:underline" data-testid={`${testid}-link`}>
            {linkLabel}
          </button>{" "}{suffix}
        </span>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="rounded-2xl max-w-2xl">
          <DialogHeader>
            <DialogTitle className="text-xl">{title}</DialogTitle>
            <DialogDescription>Devam etmek için metni sonuna kadar okuyun.</DialogDescription>
          </DialogHeader>
          <div ref={measure} onScroll={onScroll} className="text-sm text-slate-700 leading-relaxed whitespace-pre-line max-h-[55vh] overflow-y-auto">
            {text}
          </div>
          <DialogFooter>
            <Button type="button" disabled={!read} onClick={() => { onChange(true); setOpen(false); }} className="w-full h-11 rounded-xl bg-[#10B981] hover:bg-[#0EA371] text-white font-semibold" data-testid={`${testid}-accept`}>
              {read ? acceptLabel : "Lütfen sonuna kadar okuyun"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {!checked && hint && (
        <p className="mt-2 text-xs text-amber-700 flex items-start gap-1.5" data-testid={`${testid}-hint`}>
          <Info className="h-3.5 w-3.5 mt-0.5 flex-shrink-0" /> {hint}
        </p>
      )}
    </div>
  );
}

// Sadece OKUNUR yasal metin (ör. Çerez Politikası, Aydınlatma Metni): onay yok,
// tıklanınca açılır, "Kapat" ile kapanır. Bir link gibi satır içi kullanılır.
export function ReadOnlyDoc({ title, text, children, testid }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className="text-[#10B981] font-semibold hover:underline" data-testid={testid}>
        {children}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="rounded-2xl max-w-2xl">
          <DialogHeader>
            <DialogTitle className="text-xl">{title}</DialogTitle>
          </DialogHeader>
          <div className="text-sm text-slate-700 leading-relaxed whitespace-pre-line max-h-[55vh] overflow-y-auto">
            {text}
          </div>
          <DialogFooter>
            <Button type="button" onClick={() => setOpen(false)} className="w-full h-11 rounded-xl bg-[#10B981] hover:bg-[#0EA371] text-white font-semibold">Kapat</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
